import type { ResponseJsonShape } from ".";
import { FetchRequestError } from ".";

export const isWarnJson = (json: Record<string, unknown> | undefined): json is ResponseJsonShape => {
  return typeof json?.warn === "string" && typeof json?.warn_header === "string";
};

/**
 * @deprecated this is superceded by `FetchUserEncodedError`
 */
export class FetchUserError extends FetchRequestError {
  declare responseJson: ResponseJsonShape;
  constructor(statusCode: number, statusText: string, responseJson: ResponseJsonShape, originalError?: string) {
    super(statusCode, statusText, responseJson, originalError);
    this.responseJson = responseJson;
  }

  override isUnexpectedSystemError(): boolean {
    return false;
  }
}
